import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { EVENT_TYPE } from '@atlaskit/editor-common/analytics';
import { CONFIG_ITEM_KEYS } from '../../../ui/prebuilt/config-items/config-item-keys';
import { addAnalytics } from '../../../ui/utils/analytics/utils';
export var firePromptConfigNotFoundError = function firePromptConfigNotFoundError(_ref) {
  var editorView = _ref.editorView,
    dispatch = _ref.dispatch,
    prompt = _ref.prompt,
    adjustSelection = _ref.adjustSelection,
    promptText = _ref.promptText;
  var errorEventTr = addAnalytics({
    editorState: editorView.state,
    tr: editorView.state.tr,
    payload: {
      action: 'error',
      actionSubject: 'editorPluginAI',
      actionSubjectId: 'eventHubPlugin',
      attributes: {
        errorType: 'promptConfigItemNotFound',
        prompt: prompt,
        promptText: promptText,
        adjustSelection: adjustSelection
      },
      eventType: EVENT_TYPE.OPERATIONAL
    }
  });
  dispatch(errorEventTr);
};
function fireSuggestedTitleAnalyticsEvent(_ref2) {
  var _api$analytics;
  var api = _ref2.api,
    analyticSourceId = _ref2.analyticSourceId,
    additionalAttributes = _ref2.additionalAttributes;
  api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.fireAnalyticsEvent({
    // @ts-expect-error - Temporarily added analytic event for proactive title generation project
    action: 'streamingCompleted',
    // @ts-expect-error - Temporarily added analytic event for proactive title generation project
    actionSubject: 'editorPluginAI',
    // @ts-expect-error - Temporarily added analytic event for proactive title generation project
    actionSubjectId: 'eventHubPlugin',
    attributes: _objectSpread({
      promptType: CONFIG_ITEM_KEYS.SUGGEST_A_TITLE,
      modalHidden: true,
      analyticSourceId: analyticSourceId
    }, additionalAttributes),
    eventType: EVENT_TYPE.TRACK
  });
}
export var fireFallbackSuggestedTitleReturnedEvent = function fireFallbackSuggestedTitleReturnedEvent(_ref3) {
  var api = _ref3.api,
    analyticSourceId = _ref3.analyticSourceId,
    isDateTimeFormat = _ref3.isDateTimeFormat;
  fireSuggestedTitleAnalyticsEvent({
    api: api,
    analyticSourceId: analyticSourceId,
    additionalAttributes: {
      fallbackSuggestedTitleReturned: true,
      isDateTimeFormat: isDateTimeFormat
    }
  });
};
function hashString(_x) {
  return _hashString.apply(this, arguments);
}
function _hashString() {
  _hashString = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(input) {
    var encoder, data, hashBuffer, hashArray, hashHex;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          encoder = new TextEncoder();
          data = encoder.encode(input);
          _context2.next = 4;
          return crypto.subtle.digest('SHA-256', data);
        case 4:
          hashBuffer = _context2.sent;
          hashArray = Array.from(new Uint8Array(hashBuffer));
          hashHex = hashArray.map(function (b) {
            return b.toString(16).padStart(2, '0');
          }).join('');
          return _context2.abrupt("return", hashHex);
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _hashString.apply(this, arguments);
}
export var isSuggestTitle = function isSuggestTitle(configItem) {
  return configItem.key === CONFIG_ITEM_KEYS.SUGGEST_A_TITLE;
};
export var fireSuggestedTitleCompletedEvent = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref4) {
    var api, analyticSourceId, suggestedTitle, suggestedTitleFingerprint;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          api = _ref4.api, analyticSourceId = _ref4.analyticSourceId, suggestedTitle = _ref4.suggestedTitle;
          _context.next = 3;
          return hashString(suggestedTitle);
        case 3:
          suggestedTitleFingerprint = _context.sent;
          fireSuggestedTitleAnalyticsEvent({
            api: api,
            analyticSourceId: analyticSourceId,
            additionalAttributes: {
              fallbackSuggestedTitleReturned: false,
              suggestedTitleFingerprint: suggestedTitleFingerprint
            }
          });
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fireSuggestedTitleCompletedEvent(_x2) {
    return _ref5.apply(this, arguments);
  };
}();